











import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchContextSelectionComponent
  from '@/components/ToolsBar/QuickFilter/SearchContextSelectionComponent.vue';
import FilterChipsComponent from '@/components/ToolsBar/QuickFilter/FilterChipsComponent.vue';
import { FilterGetter, SearchGetter } from '@/store/getters';
import QuickFilterChipsComponent
  from '@/components/ToolsBar/QuickFilter/QuickFilterChipsComponent.vue';
import FilterOption from '@/models/FilterOption';
import Filter from '@/models/Filter';

@Component({
  name: 'quick-filter-component',
  components: { FilterChipsComponent, SearchContextSelectionComponent, QuickFilterChipsComponent },
})
export default class QuickFilterComponent extends Vue {
  private displayQuickFilters = false;

  private get displayFilters(): boolean {
    return this.$store.getters[FilterGetter.DisplayFilters];
  }

  private get Filters(): Map<string, Filter> {
    return this.$store.getters[FilterGetter.Filters];
  }

  get isLoading(): boolean {
    return this.$store.getters[SearchGetter.IsLoading];
  }

  private get specialFeaturesOptions(): Map<string, FilterOption>| undefined {
    if (this.Filters.has('specialFeatures')) {
      const { options } = this.$store.getters[FilterGetter.Filters].get('specialFeatures');
      return options;
    }
    return new Map<string, FilterOption>();
  }

  private get specialFeatureNumber(): number {
    let featureNumber = 0;
    if (this.specialFeaturesOptions) {
      featureNumber = this.specialFeaturesOptions.size;
    }

    return featureNumber;
  }

  @Watch('Filters')
  private filtersUpdates(filters: Map<string, Filter>) {
    this.displayQuickFilters = false;
    if (filters.size > 0) {
      this.displayQuickFilters = this.specialFeatureNumber > 0;
    }
  }
}
